import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function AuthModal({ open, onOpenChange, onSuccess }) {
  const { login, register } = useAuth();
  const [mode, setMode] = useState("login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      if (mode === "login") {
        await login(email, password);
        toast.success("Welcome back!");
      } else {
        await register(name, email, password);
        toast.success("Account created!");
      }
      onOpenChange(false);
      setEmail(""); setPassword(""); setName("");
      onSuccess?.();
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white border-neutral-200 text-neutral-900 sm:max-w-md" data-testid="auth-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">
            {mode === "login" ? "Welcome Back" : "Join the Club"}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-neutral-500 -mt-2">
          {mode === "login" ? "Sign in to buy, sell & trade beauty finds." : "Create your free Beauty Trade Club account."}
        </p>

        <form onSubmit={submit} className="space-y-4 mt-2">
          {mode === "register" && (
            <Input
              data-testid="auth-name-input"
              placeholder="Full name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="bg-neutral-50 border-neutral-300 h-11"
            />
          )}
          <Input
            data-testid="auth-email-input"
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="bg-neutral-50 border-neutral-300 h-11"
          />
          <Input
            data-testid="auth-password-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="bg-neutral-50 border-neutral-300 h-11"
          />
          {error && <p data-testid="auth-error" className="text-sm text-red-400">{error}</p>}
          <button
            data-testid="auth-submit-btn"
            type="submit"
            disabled={busy}
            className="w-full bg-[#E8956B] hover:bg-[#CE744A] text-white font-bold rounded-full py-3 btn-glow transition-all disabled:opacity-50"
          >
            {busy ? "Please wait..." : mode === "login" ? "Sign In" : "Create Account"}
          </button>
        </form>

        <div className="text-center text-sm text-neutral-500">
          {mode === "login" ? "New here?" : "Already have an account?"}{" "}
          <button
            data-testid="auth-toggle-mode"
            onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }}
            className="text-[#E8956B] font-semibold hover:underline"
          >
            {mode === "login" ? "Create an account" : "Sign in"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
